/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Widerrufsrecht_CheckboxInputs */

const en_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree that the provision of credits begins immediately and I waive my 14-day right of withdrawal.`)
};

const de_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich stimme zu, dass die Bereitstellung der Credits sofort beginnt, und verzichte auf mein 14-taegiges Widerrufsrecht.`)
};

const fr_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'accepte que la fourniture de credits commence immediatement et je renonce a mon droit de retractation de 14 jours.`)
};

const es_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto que la entrega de creditos comience inmediatamente y renuncio a mi derecho de desistimiento de 14 dias.`)
};

const it_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetto che la fornitura di crediti inizi immediatamente e rinuncio al mio diritto di recesso di 14 giorni.`)
};

const nl_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik ga ermee akkoord dat de levering van credits onmiddellijk begint en ik doe afstand van mijn herroepingsrecht van 14 dagen.`)
};

const pl_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgadzam sie, ze dostarczenie kredytow rozpocznie sie natychmiast i zrzekam sie mojego 14-dniowego prawa do odstapienia od umowy.`)
};

const fi_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksyn, että krediittien toimitus alkaa välittömästi ja luovun 14 päivän peruutusoikeudestani.`)
};

const da_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg accepterer, at leveringen af credits begynder straks, og jeg giver afkald pa min 14-dages fortrydelsesret.`)
};

const sv_widerrufsrecht_checkbox = /** @type {(inputs: Widerrufsrecht_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag accepterar att leveransen av krediter borjar omedelbart och jag avsagar mig min 14 dagars angerratt.`)
};

/**
* | output |
* | --- |
* | "I agree that the provision of credits begins immediately and I waive my 14-day right of withdrawal." |
*
* @param {Widerrufsrecht_CheckboxInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const widerrufsrecht_checkbox = /** @type {((inputs?: Widerrufsrecht_CheckboxInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widerrufsrecht_CheckboxInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_widerrufsrecht_checkbox(inputs)
	if (locale === "fr") return fr_widerrufsrecht_checkbox(inputs)
	if (locale === "es") return es_widerrufsrecht_checkbox(inputs)
	if (locale === "it") return it_widerrufsrecht_checkbox(inputs)
	if (locale === "nl") return nl_widerrufsrecht_checkbox(inputs)
	if (locale === "pl") return pl_widerrufsrecht_checkbox(inputs)
	if (locale === "fi") return fi_widerrufsrecht_checkbox(inputs)
	if (locale === "da") return da_widerrufsrecht_checkbox(inputs)
	if (locale === "sv") return sv_widerrufsrecht_checkbox(inputs)
	return en_widerrufsrecht_checkbox(inputs)
});